import React from "react";

interface ToggleSwitchProps {
	id: string;
	label: string;
	isChecked: boolean;
	handleToggle: (isChecked: boolean) => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = (props) => {
	const { label, isChecked, handleToggle, id } = props;

	return (
		<label htmlFor={id} className="flex items-center cursor-pointer">
			<input
				id={id}
				type="checkbox"
				className="hidden"
				checked={isChecked}
				onChange={() => handleToggle(!isChecked)}
			/>

			<div className="relative">
				<div
					className={`
            w-8 h-5 xl:w-10 xl:h-6 rounded-full shadow-inner transition-colors duration-300 ease-in-out
            ${isChecked ? "bg-blue-500" : "bg-gray-300"}
          `}
				></div>

				<div
					className={`
            absolute top-1 left-1 w-3 h-3 xl:w-4 xl:h-4 bg-white rounded-full shadow
            transform transition-transform duration-300 ease-in-out
            ${isChecked ? "translate-x-3 xl:translate-x-4" : "translate-x-0"}
          `}
				></div>
			</div>
			<span className="ml-3 text-gray-700 lg:text-xs xl:text-[12px]">
				{label}
			</span>
		</label>
	);
};

export default ToggleSwitch;
